var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryFilledV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50340_22365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.832 1.16663V2.5",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16797 1.16663V3",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72274 16.8499C10.3704 17.7412 11.3179 18.369 12.3913 18.6178C13.4647 18.8666 14.5917 18.7197 15.5655 18.2041C16.5393 17.6886 17.2942 16.8389 17.6918 15.8113C18.0893 14.7837 18.1027 13.6472 17.7295 12.6105C17.3563 11.5738 16.6215 10.7066 15.6602 10.1683C14.6989 9.62988 13.5755 9.45648 12.4966 9.67991C11.4177 9.90335 10.4556 10.5086 9.78713 11.3845C9.11868 12.2604 8.78873 13.3481 8.85792 14.4477M8.85792 14.4477L8 13.5898M8.85792 14.4477L9.71583 13.5898",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.334 2.09375C15.9616 2.09375 16.564 2.34339 17.0078 2.78711C17.4516 3.23086 17.7011 3.83339 17.7012 4.46094V6.09961H1.30469V7.5H17.7012V15.7939C17.7012 17.2851 16.4921 18.4941 15.001 18.4941H3.66797C3.04029 18.4941 2.43798 18.2446 1.99414 17.8008C1.55042 17.357 1.30078 16.7545 1.30078 16.127V4.46094C1.30088 3.83339 1.55039 3.23086 1.99414 2.78711C2.43796 2.34339 3.04038 2.09375 3.66797 2.09375H15.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72274 16.8499C10.3704 17.7412 11.3179 18.369 12.3913 18.6178C13.4647 18.8666 14.5917 18.7197 15.5655 18.2041C16.5393 17.6886 17.2942 16.8389 17.6918 15.8113C18.0893 14.7837 18.1027 13.6472 17.7295 12.6105C17.3563 11.5738 16.6215 10.7066 15.6602 10.1683C14.6989 9.62988 13.5755 9.45648 12.4966 9.67991C11.4177 9.90335 10.4556 10.5086 9.78713 11.3845C9.11868 12.2604 8.78873 13.3481 8.85792 14.4477M8.85792 14.4477L8 13.5898M8.85792 14.4477L9.71583 13.5898",
    stroke: "#575757",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4258 11.8726V14.1603L15.1416 15.8762",
    stroke: "#575757",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50340_22365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryFilledV2);
export default __webpack_public_path__ + "static/media/historyFilledV2.868a7a3a55cc6557227ca59751a3081c.svg";
export { ForwardRef as ReactComponent };